import { merge } from '../../../helper';

import addClass from '../../../general/class/addClass';
import removeClass from '../../../general/class/removeClass';

// ----------------------------------------------------------------------------

export interface IDraggableEventConfig {
    merge?: Record<string, unknown>;
    hover?: string;
    fnDragEnter?: (this: HTMLElement, evt: DragEvent) => void;
    fnDragLeave?: (this: HTMLElement, evt: DragEvent) => void;
    fnDrop?: (this: HTMLElement, evt: DragEvent) => void;
}

// ----------------------------------------------------------------------------

function draggableEvent(element: HTMLElement, config: IDraggableEventConfig = {}): void {
    const defConfig: { hover: string } & IDraggableEventConfig = {
        hover: 'is-dragover',
    };
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Create event (drag)
    element.addEventListener('drag', function (evt: DragEvent): void {
        evt.preventDefault();
        evt.stopPropagation();
    });

    // Create event (dragenter)
    element.addEventListener('dragenter', function (this: HTMLElement, evt: DragEvent): void {
        evt.preventDefault();
        evt.stopPropagation();

        // Add class (hover)
        addClass(this, defConfig.hover);

        // If using function dragenter
        if (typeof defConfig.fnDragEnter === 'function') {
            defConfig.fnDragEnter.call(this, evt);
        }
    });

    // Create event (dragover)
    element.addEventListener('dragover', function (evt: DragEvent): void {
        evt.preventDefault();
        evt.stopPropagation();
    });

    // Create event (dragleave)
    element.addEventListener('dragleave', function (this: HTMLElement, evt: DragEvent): void {
        evt.preventDefault();
        evt.stopPropagation();

        if (element.contains(evt.relatedTarget instanceof Node ? evt.relatedTarget : null)) {
            return;
        }

        // Remove class (hover)
        removeClass(this, defConfig.hover);

        // If using function dragleave
        if (typeof defConfig.fnDragLeave === 'function') {
            defConfig.fnDragLeave.call(this, evt);
        }
    });

    // Create event (drop)
    element.addEventListener('drop', function (this: HTMLElement, evt: DragEvent): void {
        evt.preventDefault();
        evt.stopPropagation();

        // Remove class (hover)
        removeClass(this, defConfig.hover);

        // If using function drop
        if (typeof defConfig.fnDrop === 'function') {
            defConfig.fnDrop.call(this, evt);
        }
    });
}

// ----------------------------------------------------------------------------

export default draggableEvent;
